export default "__VITE_ASSET__7cd6e374__"